import { createContext, useContext } from 'react';

/** The anchor the person arrived on (`#drive-03`), so that section can be marked. */
export const TargetContext = createContext<string>('');

/** `archive-target` when `id` is the arrived-on section, else nothing. */
export function useTargetClass(id: string): string | undefined {
  return useContext(TargetContext) === id ? 'archive-target' : undefined;
}
